export const safeJsonParse = (value, fallback = []) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export const capitalizeWords = (value = "") => {
  return value.replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getInitialCouponInputs = () => ({
  beat: { code: "", discount: "" },
  tutorial: { code: "", discount: "" },
  fashion: { code: "", discount: "" },
});

export const getInitialEditValues = (item, type) => {
  const genreValue = item.genres || item.genre || "";

  return {
    name:
      type === "beat"
        ? item.beatName
        : type === "tutorial"
          ? item.tutorialTitle
          : item.itemName,
    cost: item.cost,
    description: item.description || "",
    bpm: item.bpm,
    type,
    genres: genreValue
      ? genreValue
          .split(", ")
          .map((genre) => ({ value: genre.trim(), label: genre.trim() }))
      : [],
    basicCost: item.basicCost ?? 0,
    premiumCost: item.premiumCost ?? 0,
    artistName: item.artistName || "",
  };
};

export const getSelectedGenreOptions = (item, genreOptions) => {
  const genreValue = item.genres || item.genre || "";

  if (!genreValue) return [];

  const genreArray = genreValue.split(", ").map((genre) => genre.trim());

  return genreOptions.filter((option) => genreArray.includes(option.value));
};

export const buildBaseUpdateData = (editValues) => {
  const { type, name, cost, bpm, description } = editValues;

  if (type === "beat") {
    return {
      beatName: name,
      artistName: editValues.artistName || "",
      basicCost: parseInt(editValues.basicCost || 0, 10),
      premiumCost: parseInt(editValues.premiumCost || 0, 10),
      bpm: parseInt(bpm || 0, 10),
    };
  }

  if (type === "tutorial") {
    return {
      tutorialTitle: name,
      cost: parseInt(cost || 0, 10),
      description: description || "",
    };
  }

  return {
    itemName: name,
    cost: parseInt(cost || 0, 10),
  };
};

export const getGenreString = (genres) => {
  if (!Array.isArray(genres) || genres.length === 0) return "";

  return genres.map((genre) => genre.value).join(", ");
};
